import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  zoomToDisplayedAddressGraphic,
  IsPointInsideRakBoundary_4326,
} from "../map/AddressingMapView"; //TODO : change this as its a bad practise the components should communicate in ReactWay
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import LightTooltip from "../../components/ui/LightTooltip";
import Link from "@material-ui/core/Link";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import {
  Grid,
  Snackbar,
  ButtonGroup,
  Avatar,
  Card,
  CardHeader,
  CardContent,
  Box,
  CardActions,
  Fab,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { LocationOn, Language, Share, Edit, Warning } from "@material-ui/icons";
import {
  StreetSvg2,
  PolygonSvg,
  LetterBoxSvg,
} from "../../components/ui/Icons/CustomIcons";
import { Clear as ClearIcon } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import w3wIcon from "../../assets/img/W3W.png";
import plusCodeIcon from "../../assets/img/plusCode.png";
import MakaniICon from "../../assets/img/makani-icon.png";
import { Alert } from "@material-ui/lab";

import { clearAddressDetails } from "../../redux/reducers/addressDetailsReducer";
import { clearAddressResult } from "../../redux/actions/addressingResultActions";
import { setSidePanelopen } from "../../redux/actions/mapPanelControlActions";
//update Shamnas
import { setActivePage } from "../../redux/actions/appSettingsActions";
import { useHistory } from "react-router-dom";
// import { useCookies } from "react-cookie";

import ReportIssueDialog from "./ReportIssueDialog";
import ShareAddressDialog from "./ShareAddressDialog";
import { useTranslation } from "react-i18next";
import {
  LatLngInfo,
  PlusCodeInfo,
  What3WordsInfo,
  MakaniInfo,
} from "./InfoHelp";
import Collapse from "@material-ui/core/Collapse";

import ShareAddressComponent from "./ShareAddressComponent";

import { WhatsappShareButton, WhatsappIcon, EmailIcon ,  } from "react-share"

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    overflow: "auto",
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  divider: {
    margin: theme.spacing(1),
  },
  card: {
    width: "100%",
  },
  cardHeader: {
    //backgroundColor: "lightgrey",
    backgroundColor: theme.palette.common.lightgrey,
    padding: "6px",
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
  },
  section3: {
    // margin: theme.spacing(3, 1, 1),
    height: "100%",
    direction: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  items: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  avatar: {
    //backgroundColor: red[500],
    backgroundColor: theme.palette.primary.light,
  },
  cardAction: {
    justifyContent: "flex-end",
  },

  customAccordian: {},
}));

function AddressDetailsPane(props) {
  // const [cookies, setCookie] = useCookies(["page"]);
  // const [cookiesStore, setCookieStore] = useCookies(["store"]);
  const classes = useStyles();
  const history = useHistory();
  const { t, i18n } = useTranslation("mapPage");
  const [showOtherAddressFormats, setShowOtherAddressFormats] = useState(false);
  //Getting Varialbes from Store
  const store_address_result = props.addressingResult;
  const store_address_result_loading = props.addressingResult.loading;

  const store_addressDetails = props.addressDetails;
  const store_addressDetailsData = store_addressDetails.data;
  const isLangArActive = props.appSettings.language === "ar";

  // const store_addressDetailsData_hasValue =()=>{
  //   if(!store_addressDetailsData) return false
  //   if(typeof(store_addressDetailsData) === "object"){
  //     return Object.keys(store_addressDetailsData).length > 0
  //   }else if(Array.isArray(store_addressDetailsData)){
  //     return (store_addressDetailsData.length > 0)
  //   }
  // }

  const hasValue = (obj) => {
    if (!obj) return false;
    if (typeof obj === "object") {
      return Object.keys(obj).length > 0;
    } else if (Array.isArray(obj)) {
      return obj.length > 0;
    }
  };

  const AddressPointId = store_addressDetailsData.addressPointId;
  const AddNum = store_addressDetailsData.addressId;
  const StNameEn = store_addressDetailsData.streetNameEnglish;
  const StNameAr = store_addressDetailsData.streetNameArabic;
  const Emirate = store_addressDetailsData.emirate;

  const AreaEn = store_addressDetailsData.areaNameEn;
  const AreaAr = store_addressDetailsData.areaNameAr;

  const PostalCode = store_addressDetailsData.postalCode;
  const ParcelId = store_addressDetailsData.parcelId;
  const Lat = store_addressDetailsData.latitude;
  const Lng = store_addressDetailsData.longitude;

  const PlusCode = store_addressDetailsData.plusCode
    ? store_addressDetailsData.plusCode
    : "";
  const ThreeWordsEn = store_addressDetailsData.threeWordsEn
    ? store_addressDetailsData.threeWordsEn
    : "";
  const ThreeWordsAr = store_addressDetailsData.threeWordsAr
    ? store_addressDetailsData.threeWordsAr
    : "";

  const ThreeWordsUrdu = store_addressDetailsData.threeWordsUrdu
    ? store_addressDetailsData.threeWordsUrdu
    : "";

  const BuildingNameE = store_addressDetailsData.buidlingNameE
    ? store_addressDetailsData.buidlingNameE
    : "";

  const BuildingNameA = store_addressDetailsData.buildingNameA
    ? store_addressDetailsData.buildingNameA
    : "";

  const CommunityNameE = store_addressDetailsData.communityNameE
    ? store_addressDetailsData.communityNameE
    : "";

  const CommunityNameA = store_addressDetailsData.communityNameA
    ? store_addressDetailsData.communityNameA
    : "";

  const MakaniNumber = store_addressDetailsData.makani
    ? store_addressDetailsData.makani
    : null;

  const [shareOpen, setShareOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState(false);
  const [loginAlertflg, setLoginAlertflg] = useState(false);

  const zoomToMapAddressGraphic = function () {
    //Here Before Zooming , detect if it mobile and if mobile hide the AddressDetails Pane
    //close the Address details panel if mobile only
    if (isMobileOnly) {
      props.closeAddressPanel();
      setTimeout(() => {
        //wait unitll the panel closes and zoom
        zoomToDisplayedAddressGraphic();
      }, 200);
    } else {
      zoomToDisplayedAddressGraphic();
    }
  };
  const handleShareClose = () => {
    setShareOpen(false);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
    setToastMsg("");
  };
  const successMessageToast = (Message) => {
    setToastMsg(Message);
    setSnackOpen(true);
  };

  const getGooglePlusCodeLink = (plusCode) => {
    return "https://www.google.com/maps/place/" + plusCode.replace("+", "%2B");
  };

  const getGoogleLatLngLink = (lat, lng) => {
    return "https://www.google.com/maps/place/" + lat + "+" + lng;
  };

  const getW3WLink = (w3w) => {
    return "https://what3words.com/" + w3w;
  };

  const WidgetPaneToggler = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <button
        style={{ width: "23px", height: "20px", cursor: "pointer" }}
        onClick={handleExpandClick}
      >
        {" "}
        ^{" "}
      </button>

      {/* <ExpandMore
        expand={showOtherAddressFormats}
        onClick={handleExpandClick}
        aria-expanded={showOtherAddressFormats}
        aria-label="show other address formats"
      >
        <ExpandMoreIcon color="primary" />
      </ExpandMore> */}
    </div>
  );
  const OtherAddressFormatsAccordian = () => (
    <>
      {/* <Accordion expanded={showOtherAddressFormats} square={true}>
      <AccordionSummary style={{maxHeight : "1px"}}></AccordionSummary>
      <AccordionDetails> */}
      {/* <Slide direction="right" in={showOtherAddressFormats}  timeout={5000} unmountOnExit > */}
      <Collapse
        in={showOtherAddressFormats}
        timeout={5000}
        unmountOnExit
        style={{ paddingBottom: "16px" }}
      >
        <div hidden={false}>
          <Divider className={classes.divider} />
          <PlusCodeBit />
          <Divider className={classes.divider} />
          <LatLngAddressBit />
          <Divider className={classes.divider} />
          <W3wBit />
          {/* For Makani */}
          <MakaniBit />
        </div>
      </Collapse>
      {/* </Slide> */}
      {/* </AccordionDetails>
      </Accordion> */}
      <div className="displayOtherAddressFab">
        <ExpandMore
          expand={showOtherAddressFormats}
          onClick={handleExpandClick}
          aria-expanded={showOtherAddressFormats}
          aria-label="show other address formats"
        >
          <LightTooltip
            title={
              showOtherAddressFormats ? t("MinimizeTooltip") : t("ViewTooltip")
            }
            arrow
            interactive
          >
            <Fab size="small" color="primary">
              <ExpandMoreIcon />
            </Fab>
          </LightTooltip>
        </ExpandMore>
      </div>
    </>
  );

  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} style={{ padding: "0px" }} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));

  const handleExpandClick = () => {
    setShowOtherAddressFormats(!showOtherAddressFormats);
  };

  const AddressBit = () => (
    <>
      <Box p={1}>
        <Grid container alignItems="center">
          <Grid item xs={2} sm={2} md={2} lg={2} mt={2}>
            <IconButton
              //size="small"
              onClick={() => zoomToMapAddressGraphic()}
              color="primary"
            >
              <LocationOn fontSize="large" />
            </IconButton>
            {/* <LocationOn
              style={{ cursor: "pointer" }}
              color="primary"
              fontSize="large"
              onClick={() => zoomToMapAddressGraphic()}
            /> */}
          </Grid>
          <Grid item xs={10} sm={10} md={10} lg={10}>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                <div>
                  {t("HouseNumberlbl")} &nbsp; {AddNum}
                </div>
                {/* {AddNum}, {StNameEn} {StNameEn === StNameAr ? null : `(${StNameAr})`} */}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                {isLangArActive ? (
                  StNameAr ? (
                    <div>
                      {t("StreetNamelbl")} &nbsp; {StNameAr}
                    </div>
                  ) : (
                    StNameAr
                  )
                ) : StNameEn ? (
                  <div>
                    {t("StreetNamelbl")} &nbsp; {StNameEn}{" "}
                  </div>
                ) : (
                  StNameEn
                )}
                {/* {AddNum}, {StNameEn} {StNameEn === StNameAr ? null : `(${StNameAr})`} */}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="caption" variant="body2">
                {isLangArActive ? (
                  BuildingNameA ? (
                    <div>
                      {t("BuildingNamelbl")} &nbsp; {BuildingNameA}
                    </div>
                  ) : (
                    BuildingNameA
                  )
                ) : BuildingNameE ? (
                  <div>
                    {t("BuildingNamelbl")} &nbsp; {BuildingNameE}
                  </div>
                ) : (
                  BuildingNameE
                )}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                {isLangArActive ? (
                  CommunityNameA ? (
                    <div>
                      {t("CommunityNamelbl")} &nbsp; {CommunityNameA}
                    </div>
                  ) : (
                    CommunityNameA
                  )
                ) : CommunityNameA ? (
                  <div>
                    {t("CommunityNamelbl")} &nbsp; {CommunityNameE}
                  </div>
                ) : (
                  CommunityNameE
                )}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                {isLangArActive ? (
                  AreaAr ? (
                    <div>
                      {t("AreaName")} &nbsp; {AreaAr}
                    </div>
                  ) : (
                    AreaAr
                  )
                ) : AreaEn ? (
                  <div>
                    {t("AreaName")} &nbsp; {AreaEn}
                  </div>
                ) : (
                  AreaEn
                )}
                {/* {AreaEn} {AreaEn == AreaAr ? null : `(${AreaAr})`} */}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                {PostalCode ? (
                  <div>
                    {t("PostalCode")} &nbsp; {PostalCode}
                  </div>
                ) : (
                  PostalCode
                )}
              </Typography>
            </Grid>
            <Grid container>
              <Typography color="textPrimary" variant="body2">
                {isLangArActive ? (
                  <div>
                    {t("Emirate")} &nbsp; {"رأس الخيمة"}
                  </div>
                ) : (
                  <div>
                    {t("Emirate")} &nbsp; {"Ras Al Khaimah"}
                  </div>
                )}
                {/* {Emirate} */}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* <OtherAddressFormatsAccordian/> */}

        {/* <Collapse in={showOtherAddressFormats} timeout="5000" unmountOnExit> */}
        <OtherAddressFormatsAccordian />
        {/* <UserActionButtons /> */}
        {/* </Collapse> */}

        {/* <TryCollapsePanel /> */}
        {/* <CardActions disableSpacing> */}
        {/* <Button size="small" onClick={()=>{ setShowOtherAddressFormats( !showOtherAddressFormats)}} variant="outlined" color="primary" fullWidth>
            {showOtherAddressFormats ? "Hide Other Address Formats" : "View Other Address Formats"}
            </Button> */}

        {/* <ExpandMore
          expand={showOtherAddressFormats}
          onClick={handleExpandClick}
          aria-expanded={showOtherAddressFormats}
          aria-label="show other address formats"
        >
          <ExpandMoreIcon color="primary"/>
        </ExpandMore> */}
        {/* </CardActions> */}
      </Box>
      <UserActionButtons />
      {/* <WidgetPaneToggler/> */}
    </>
  );

  const LatLngAddressBit = () => (
    <>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <LightTooltip title="View on Google Maps" arrow interactive>
            <IconButton
              size="small"
              href={getGoogleLatLngLink(Lat, Lng)}
              target="_blank"
              rel="noreferrer"
            >
              <Language color="secondary" fontSize="large" />
            </IconButton>
          </LightTooltip>
          {/* <Language color="secondary" fontSize="large" /> */}
        </Grid>
        <Grid item xs={9} sm={9} md={9} lg={9}>
          <Typography color="textSecondary" variant="body2">
            <Link
              href={getGoogleLatLngLink(Lat, Lng)}
              rel="noerferrer"
              target="_blank"
              color="textSecondary"
            >
              {Lat} {Lng}
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1}>
          <LightTooltip title={<LatLngInfo />} arrow interactive>
            <IconButton
              color="textSecondary"
              href="https://en.wikipedia.org/wiki/Geographic_coordinate_system#Latitude_and_longitude"
              target="_blank"
            >
              <InfoOutlinedIcon />
            </IconButton>
          </LightTooltip>
        </Grid>
      </Grid>
    </>
  );

  const PlusCodeBit = () => (
    <>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <LightTooltip title="View on Google Maps" arrow interactive>
            <IconButton
              size="small"
              href={getGooglePlusCodeLink(PlusCode)}
              target="_blank"
              rel="noreferrer"
            >
              <Avatar src={plusCodeIcon} />
            </IconButton>
          </LightTooltip>
          {/* <Avatar src={plusCodeIcon}  href={getGooglePlusCodeLink(PlusCode)} target="_blank"/> */}
        </Grid>
        <Grid item xs={9} sm={9} md={9} lg={9}>
          <Typography color="textSecondary" variant="body2">
            <Link
              href={getGooglePlusCodeLink(PlusCode)}
              rel="noerferrer"
              target="_blank"
              color="textSecondary"
            >
              {PlusCode}
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1}>
          <LightTooltip title={<PlusCodeInfo />} arrow interactive>
            <IconButton
              color="textSecondary"
              href="https://en.wikipedia.org/wiki/Open_Location_Code"
              target="_blank"
            >
              <InfoOutlinedIcon />
            </IconButton>
            {/* <InfoOutlinedIcon color="textSecondary" /> */}
          </LightTooltip>
        </Grid>
      </Grid>
    </>
  );

  const W3wBit = () => (
    <>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={2} sm={2} md={2} lg={2}>
          <LightTooltip title="View Location on What3words" arrow interactive>
            <IconButton
              size="small"
              href={getW3WLink(ThreeWordsEn)}
              target="_blank"
              rel="noreferrer"
            >
              <Avatar src={w3wIcon} />
            </IconButton>
          </LightTooltip>
          {/* <Avatar
                  src={w3wIcon}
                  href={getW3WLink(ThreeWordsEn)}
                  target="_blank"
                /> */}
        </Grid>
        <Grid item xs={9} sm={9} md={9} lg={9}>
          <Grid container>
            <Typography color="textSecondary" variant="body2">
              {/* {ThreeWordsAr} */}
              <Link
                href={getW3WLink(ThreeWordsAr)}
                rel="noerferrer"
                target="_blank"
                color="textSecondary"
              >
                {ThreeWordsAr}
              </Link>
            </Typography>
          </Grid>
          <Grid container>
            <Grid container>
              <Typography color="textSecondary" variant="body2">
                <Link
                  href={getW3WLink(ThreeWordsEn)}
                  rel="noerferrer"
                  target="_blank"
                  color="textSecondary"
                >
                  {ThreeWordsEn}
                </Link>

                {/* {ThreeWordsEn} */}
              </Typography>
            </Grid>
            <Typography color="textSecondary" variant="body2">
              <Link
                href={getW3WLink(ThreeWordsUrdu)}
                rel="noerferrer"
                target="_blank"
                color="textSecondary"
              >
                {ThreeWordsUrdu}
              </Link>
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={1} sm={1} md={1} lg={1}>
          <LightTooltip title={<What3WordsInfo />} arrow interactive>
            <IconButton
              href="https://en.wikipedia.org/wiki/What3words"
              target="_blank"
            >
              <InfoOutlinedIcon />
            </IconButton>
          </LightTooltip>
        </Grid>
      </Grid>
    </>
  );

  const MakaniBit = () => (
    <>
      {MakaniNumber ? (
        <>
          <Divider className={classes.divider} />
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <Avatar src={MakaniICon} size="small" />
            </Grid>
            <Grid item xs={9} sm={9} md={9} lg={9}>
              <Typography color="textSecondary" variant="body2">
                {MakaniNumber}
              </Typography>
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1}>
              <LightTooltip title={<MakaniInfo />} arrow interactive>
                <IconButton
                  color="textSecondary"
                  href="https://www.makani.ae"
                  target="_blank"
                >
                  <InfoOutlinedIcon />
                </IconButton>
                {/* <InfoOutlinedIcon color="textSecondary" /> */}
              </LightTooltip>
            </Grid>
          </Grid>
        </>
      ) : null}
    </>
  );

  //To Hide Parcel Id --- Not showing this
  const AdditionalAddressInfoBit = () => (
    <div className={classes.section2}>
      <Typography
        gutterBottom
        variant="subtitle1"
        style={{ fontWeight: "bold" }}
      >
        {t("AdditionalInformation")} :
      </Typography>
      <div>
        <Grid container alignItems="center">
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Typography color="textPrimary" variant="body2">
              {t("ParcelID")}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={8} lg={8}>
            <Typography color="textPrimary" variant="body2">
              {/* {ParcelId} */}
              <Link
                href="#"
                onClick={zoomToMapAddressGraphic}
                color="secondary"
              >
                {ParcelId}
              </Link>
              {/* <IconButton
            size="small"
            onClick={zoomToMapAddressGraphic}
          >
            <PolygonSvg />
          </IconButton> */}
              {/* <ZoomInSharpIcon
            className="zoomInIcon"
            fontSize="small"
            style={{ cursor: "pointer" }}
            color="secondary"
            fontSize="large"
            onClick={() => zoomToMapAddressGraphic()}
          /> */}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  const UserActionButtons = () => (
    <Box>
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="center"
      >
        {/* <div className={classes.section3}> */}
        <ButtonGroup>
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.button}
            startIcon={<Share />}
            onClick={() => {
              setShareOpen(true);
            }}
          >
            {t("Share")}
          </Button> */}
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            startIcon={<Edit />}
            onClick={HandleReportIssue}
          >
            {t("Report")}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            className={classes.button}
            startIcon={<ClearIcon />}
            onClick={() => {
              props.clearAddressDisplay();
            }}
          >
            {t("Clear")}
          </Button>
        </ButtonGroup>
        {/* </div> */}
      </Grid>
      {/* Just Using the existing Share Email functionality (passing the "shareOpen" state )- insted of doing in the ShareAddressing Component-- to save development time*/}
      <ShareAddressComponent
        store_addressDetailsData={store_addressDetailsData}
        setShareOpen={setShareOpen}
        lang={isLangArActive ? "ar" : "en"}
      />
    </Box>
  );

  const DisplayAddressHTML = () => {
    return (
      <div>
        <div className={classes.section1}>
          <Card className={classes.card} raised={true}>
            {/* <CardHeader
            className={classes.cardHeader}
            avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                {t("AdrsAvatar")}
              </Avatar>
            }
            title={t("AddressInformation")}
          /> */}
            <CardContent>
              <AddressBit />
              {/* <Divider className={classes.divider} /> */}
            </CardContent>
          </Card>
          {/* <WidgetPaneToggler/> */}
        </div>

        {/* <AdditionalAddressInfoBit />  Hiding Parcel Id*/}
        {/* <Divider variant="middle" />
        <UserActionButtons /> */}
      </div>
    );
  };

  const DisplayClickInsideRakBoundary = () => {
    return (
      // <div>
      //   <div className={classes.section1}>
      //     <Card className={classes.card} raised={true}>
      //       <CardContent>
      //         <Grid container alignItems="center" spacing={1}>
      //           <Grid item xs={2} sm={2} md={2} lg={2}>
      //             <Warning style={{ color: "#ffb74d" }} fontSize="large" />
      //           </Grid>
      //           <Grid item xs={9} sm={9} md={9} lg={9}>
      //             <Typography variant="subtitle2" color="secondary">
      //               {t("ClickInsideRAKMessage")}
      //             </Typography>
      //           </Grid>
      //         </Grid>
      //       </CardContent>
      //       <CardActions className={classes.cardAction}>
      //         <Button
      //           variant="outlined"
      //           color="primary"
      //           className={classes.button}
      //           startIcon={<ClearIcon />}
      //           onClick={() => {
      //             props.clearAddressDisplay();
      //           }}
      //         >
      //           {t("Clear")}
      //         </Button>
      //       </CardActions>
      //     </Card>
      //   </div>
      // </div>
      <div className={classes.section1}>
        <Card className={classes.card}>
          {/* <CardHeader
              className={classes.cardHeader}
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  A
                </Avatar>
              }
              title="Address Information"
            /> */}
          <CardContent>
            {/* <LatLngBit lat={mapClicklatlng.lat} lng={mapClicklatlng.lng} /> */}
            <LatLngBit
              lat={store_address_result.fetchInput.y.toFixed(6)}
              lng={store_address_result.fetchInput.x.toFixed(6)}
            />
            <Divider className={classes.divider} />
            <Typography variant="subtitle2" color="secondary">
              {/* No Address Details found for this locatoin */}
              {t("NoAddressDetails")}
            </Typography>
            {/* <Divider className={classes.divider} /> */}
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              startIcon={<ClearIcon />}
              onClick={() => {
                props.clearAddressDisplay();
              }}
            >
              {t("Clear")}
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  };

  const ErrorDisplayHTML = () => (
    <div className={classes.section1}>
      <Card className={classes.card}>
        <CardContent>
          <Divider className={classes.divider} />
          <Typography variant="subtitle2" color="secondary">
            {t("errormsg")}
          </Typography>
        </CardContent>
        {/* <CardActions className={classes.cardAction}>
          <ReportIssueButton />
        </CardActions> */}
      </Card>
    </div>
  );

  const LatLngBit = (props) => (
    <Grid container>
      <Grid item xs={4} sm={4} md={4} lg={4}>
        <Language color="secondary" fontSize="large" />
      </Grid>
      <Grid item xs={8} sm={8} md={8} lg={8}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textSecondary" variant="body2">
              {props.lat}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textSecondary" variant="body2">
              {props.lng}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  const ReportIssueButton = () => (
    <Button
      variant="contained"
      color="secondary"
      className={classes.button}
      startIcon={<Edit />}
      onClick={HandleReportIssue}
    >
      {t("Report")}
    </Button>
  );

  // Update Shamnas  -- to Report issue for logged in users only
  const HandleReportIssue = () => {
    // setReportOpen(true);
    // return;
    // uncomment to enable login to report issue
    let userName = props.appSettings.userCredentials.user
      ? props.appSettings.userCredentials.user.userName
      : props.appSettings.userCredentials.acmUser.userName;
    if (userName == "AdrsAnonymousUsr") {
      // setCookieStore("store", JSON.stringify(props.addressingResult), {
      //   path: "/",
      // });
      // props.setActivePage("Login");
      // history.push("/Login");
      setLoginAlertflg(true);
    } else setReportOpen(true);
  };

  const DisplayWelcomeHTML = () => (
    <div className={classes.section1}>
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <Avatar aria-label="recipe" className={classes.avatar}>
              {t("AdrsAvatar")}
            </Avatar>
          }
          title={t("AddressingService")}
        />
        <CardContent>
          <Divider className={classes.divider} />
          <Typography variant="body1" color="secondary">
            <b>{t("welcomeMsg")}</b>
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="body2" color="secondary">
            {t("RAKAddressInfo")}
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="caption" color="secondary">
            <p>
              {t("findmsg")} <b> {t("msg1")} </b> <i> {t("or")} </i>{" "}
              <b> {t("searchBar")} </b> {t("searchMsg")}
            </p>
          </Typography>
        </CardContent>
      </Card>
    </div>
  );

  const DisplayContent = () => {
    if (store_address_result_loading || store_addressDetails.loading)
      return (
        <Grid
          style={{ height: 100 }}
          container
          justify="center"
          alignItems="center"
        >
          <CircularProgress size="4rem" color="primary" />
        </Grid>
      );
    else if (!store_address_result.fetchType) {
      //nothing searched yet or cleared previous seach
      return <DisplayWelcomeHTML />;
    } else if (store_address_result.error || store_addressDetails.error) {
      //Error Occured  Please constact admin
      return <ErrorDisplayHTML />;
    } else if (
      store_address_result.fetchType == "Text_Search" &&
      !hasValue(store_addressDetailsData)
      // store_addressDetailsData.length < 1
    ) {
      //address search didnt yield result
      return (
        <div>
          {" "}
          <NoAddressFoundContent />
        </div>
      );
    } else if (
      store_address_result.fetchType == "Suggestion_Select" &&
      !hasValue(store_addressDetailsData)
      //store_addressDetailsData.length < 1
    ) {
      //means street or area or post found and No Address Point found
      //return <div> No Address Found</div>;
      return (
        <div>
          {" "}
          <NoAddressFoundContent />
        </div>
      );
    } else if (
      store_address_result.fetchType == "Map_Click" &&
      !hasValue(store_addressDetailsData)
    ) {
      var isInside = IsPointInsideRakBoundary_4326(
        store_address_result.fetchInput
      );
      if (isInside) {
        return <NoAddressFoundContent />;
      } else {
        return <DisplayClickInsideRakBoundary />;
      }
    } else {
      return <DisplayAddressHTML />;
    }
  };

  //const [mapClicklatlng ,setMapClickLatLng ] = useState({lat : '' , lng : ''})

  // useEffect(() => {
  //   let mounted = true
  //   if(store_address_result_loading) return
  //  if (store_address_result.fetchType != "Map_Click") {
  //    mounted && setMapClickLatLng({ lat: "", lng: "" });
  //    return;
  //  }
  //  if(hasValue(store_addressDetailsData)) {
  //   mounted && setMapClickLatLng({ lat: "", lng: "" });
  //   return;
  //  }

  //   // if((!store_address_result.fetchType == "Map_Click" )|| ( !store_addressDetailsData.length < 1)){
  //   //   mounted && setMapClickLatLng({lat : '', lng:''})
  //   //   return
  //   // }

  //   let mapX = store_address_result.fetchInput.x;
  //   let mapY = store_address_result.fetchInput.y;
  //   const point32640 = new Point({
  //     x: mapX,
  //     y: mapY,
  //     spatialReference: { wkid: 32640 },
  //   });
  //   let outSpatialReference = new SpatialReference({ wkid: 4326 });
  //   esriProject.load().then(() => {
  //     let projectPnt = esriProject.project(point32640, outSpatialReference);
  //     mounted && setMapClickLatLng({ lat: projectPnt.y, lng: projectPnt.x });
  //   });

  //   return(()=>{
  //     mounted = false
  //   })

  // }, [store_addressDetails]);

  const NotPointAddressFoundContent = () => {
    if (!store_address_result.candidates || !store_address_result.candidates[0])
      return <></>;
    const address_candidate_attributes =
      store_address_result.candidates[0].attributes;
    const address_type = address_candidate_attributes.Addr_type;
    const address = address_candidate_attributes.Match_addr;

    const display_cnt = (address_typ, address_content, icon) => (
      <div className={classes.section1}>
        <Card className={classes.card}>
          <CardContent>
            <Divider className={classes.divider} />

            <Typography variant="subtitle2" color="secondary">
              <IconButton
                onClick={() => {
                  zoomToMapAddressGraphic();
                }}
              >
                {" "}
                {icon}{" "}
              </IconButton>
              <b>{address_typ} </b> : {address_content}
            </Typography>
          </CardContent>
          <CardActions className={classes.cardAction}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              startIcon={<ClearIcon />}
              onClick={() => {
                props.clearAddressDisplay();
              }}
            >
              {t("Clear")}
            </Button>
          </CardActions>
        </Card>
      </div>
    );

    switch (address_type) {
      case "StreetName": //street
        return display_cnt(t("Street"), address, <StreetSvg2 />);
      case "Locality": //Area
        return display_cnt(t("Area"), address, <PolygonSvg />);
      case "Postal":
        return display_cnt(t("PostalArea"), address, <LetterBoxSvg />);
      default:
        return <></>;
    }
  };

  const NoAddressFoundContent = () => {
    if (store_address_result.fetchType == "Map_Click") {
      //get xy and display that with Report Issue button

      return (
        <div className={classes.section1}>
          <Card className={classes.card}>
            {/* <CardHeader
              className={classes.cardHeader}
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  A
                </Avatar>
              }
              title="Address Information"
            /> */}
            <CardContent>
              {/* <LatLngBit lat={mapClicklatlng.lat} lng={mapClicklatlng.lng} /> */}
              <LatLngBit
                lat={store_address_result.fetchInput.y.toFixed(6)}
                lng={store_address_result.fetchInput.x.toFixed(6)}
              />
              <Divider className={classes.divider} />
              <Typography variant="subtitle2" color="secondary">
                {/* No Address Details found for this locatoin */}
                {t("NoAddressDetails")}
              </Typography>
              {/* <Divider className={classes.divider} /> */}
            </CardContent>
            <CardActions className={classes.cardAction}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                startIcon={<ClearIcon />}
                onClick={() => {
                  props.clearAddressDisplay();
                }}
              >
                {t("Clear")}
              </Button>
              <ReportIssueButton />
            </CardActions>
          </Card>
        </div>
      );
    } else if (store_address_result.fetchType == "Text_Search") {
      //diplay no address found for the User Search Text
      let searchTxt = store_address_result.fetchInput;
      return (
        <div className={classes.section1}>
          <Card className={classes.card}>
            {/* <CardHeader
              className={classes.cardHeader}
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  A
                </Avatar>
              }
              title="Address Information"
            /> */}
            <CardContent>
              <Divider className={classes.divider} />
              <Typography variant="subtitle2" color="secondary">
                {/* No Address Details found for Search : {searchTxt} */}
                {t("NoAddressDetailsFor")} : {searchTxt}
              </Typography>
            </CardContent>
            <CardActions className={classes.cardAction}>
              <ReportIssueButton />
            </CardActions>
          </Card>
        </div>
      );
    } else if (store_address_result.fetchType == "Suggestion_Select") {
      //mean NonPoint address is selected from the Suggestion
      //This point should not happen
      // return <ErrorDisplayHTML/>
      // return <div>{store_address_result.candidates[0].address}</div>
      return <NotPointAddressFoundContent />;
    } else {
      return <ErrorDisplayHTML />;
    }
  };

  const LoginAlert = () => {
    return (
      <Dialog
        open={loginAlertflg}
        onClose={() => {
          setLoginAlertflg(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("AlertToLoginHeading")}
        </DialogTitle>
        <DialogContent>
          <Grid container alignItems="center" justify="center">
            <Grid item md={2} justify="center">
              <ReportProblemOutlinedIcon
                style={{ fontSize: 60, color: "#ffb74d" }}
              />
            </Grid>
            <Grid item md={10}>
              <DialogContentText color="textPrimary">
                {t("AlertToLoginMsg")}
              </DialogContentText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLoginAlertflg(false);
            }}
            color="primary"
          >
            {t("AlertToLoginCloseBtn")}
          </Button>
          <Button
            onClick={() => {
              history.push("/Login");
            }}
            color="primary"
            autoFocus
          >
            {t("AlertToLoginBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <div className={classes.root}>
      <DisplayContent />

      {shareOpen ? (
        <ShareAddressDialog
          data={{
            AddressPointId : AddressPointId,
            //Address: AddNum + ", " + StNameEn +" (" + StNameAr +") "+ ", " + AreaEn + " (" + AreaAr + ") "+ "," + PostalCode + "," + Emirate ,
            //Address: `${AddNum} , ${StNameEn} ( ${StNameAr} )<br/>${AreaEn}( ${AreaAr} )<br/>${PostalCode}<br/>${Emirate}`,
            Address: !isLangArActive
              ? `${AddNum} , ${StNameEn} , ${AreaEn} , ${PostalCode} , Ras Al Khaimah`
              : `${AddNum} ,  ${StNameAr} , ${AreaAr} , ${PostalCode} , رأس الخيمة`,
            PlusCode: PlusCode,
            ThreeWordsAddress: ThreeWordsEn,
            ThreeWordsAddressAR: ThreeWordsAr,
            Latitude: Lat,
            Longitude: Lng,
            ParcelId: ParcelId,
            Makani: MakaniNumber ? MakaniNumber : "",
          }}
          token={props.appSettings.userCredentials.token}
          open={shareOpen}
          onClose={handleShareClose}
          onSuccess={(msg) => successMessageToast(msg)}
        />
      ) : (
        ""
      )}
      {reportOpen ? (
        <ReportIssueDialog
          token={props.appSettings.userCredentials.token}
          open={reportOpen}
          onClose={() => setReportOpen(false)}
          onSuccess={(msg) => successMessageToast(msg)}
          lat={Lat ? Lat : props.addressingResult.fetchInput.y}
          lng={Lng ? Lng : props.addressingResult.fetchInput.x}
        />
      ) : (
        ""
      )}
      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleSnackClose}
      >
        <Alert onClose={handleSnackClose} severity="success">
          {toastMsg}
        </Alert>
      </Snackbar>
      <LoginAlert />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    addressingResult: state.addressingResult,
    addressDetails: state.addressDetails,
    appSettings: state.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAddressDisplay: () => {
      dispatch(clearAddressResult());
      dispatch(clearAddressDetails());
    },
    // Update Shamnas -- to activate Login to Report
    setActivePage: (page) => dispatch(setActivePage(page)),
    closeAddressPanel: () => {
      return dispatch(setSidePanelopen(false)); //to display the sidePanel
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressDetailsPane);
